import { PRODUCT_LIST_LAYOUT_VIEW } from 'components/visibility/duck'

// Null is the existing grid default before the view selector initializes.
// Every category and market uses the same grid; the alternative view stays intact.
const isCategoryGridView = ({ view }) =>
  view == null || view === PRODUCT_LIST_LAYOUT_VIEW.GRID_VIEW

export default isCategoryGridView
